import $ from 'jquery'



//&callback=getIP
$.ajax({
    url: "https://api.ipify.org?format=json",
    success: function(response_json){
        $('#IpAddress').val(response_json.ip);

        if ($('#Ip').length > 0)
            $('#Ip').val(response_json.ip);
    },
    timeout: 1000 //in milliseconds
});